/** Register SW without pulling workbox-window into the main bundle (keeps LCP path lean). */
export function registerServiceWorkerWhenIdle(): void {
  if (!import.meta.env.PROD || typeof navigator === "undefined" || !("serviceWorker" in navigator)) {
    return;
  }

  const register = () => {
    navigator.serviceWorker
      .register("/sw.js", { scope: "/" })
      .then((registration) => {
        registration.addEventListener("updatefound", () => {
          const installing = registration.installing;
          if (!installing) return;
          installing.addEventListener("statechange", () => {
            if (installing.state === "installed" && navigator.serviceWorker.controller) {
              window.location.reload();
            }
          });
        });
      })
      .catch(() => {
        /* ignore */
      });
  };

  if (typeof globalThis.requestIdleCallback === "function") {
    globalThis.requestIdleCallback(register, { timeout: 12000 });
  } else {
    globalThis.setTimeout(register, 4000);
  }
}
